<template>
  <div>
    <!--TODO get rid of this paddingrow please-->
    <v-row v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
           v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
           fluid
           style="background-color: unset">
      <v-col cols="12">
        <p v-if=" instrument.description">{{ instrument.description }}</p>
        <h3>Kursentwicklung</h3>
        <fin-chart2 :options="chartOptions"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import FinChartBuilder from "@/components/common/Chart2/FinChartBuilder"
import FinChart2 from "@/components/common/Chart2/FinChart2"

export default {
  name: 'FinEtfPageOverview',
  components: {FinChart2},
  props: {
    instrument: {},
    realtimeSubscription: {},
  },
  data: () => ({
    chartOptions: null,
  }),
  watch: {
    instrument: {
      immediate:true,
      handler(val){
        this.chartOptions = {
          chart: {
            height: 400,
          },
          rangeSelector: {
            initSelection: 2
          },
          series: [{
            name: val.name,
            data: FinChartBuilder.mapTimeSeriesPoint([...val.mainListing.timeSeries, ...val.timeSeriesRT]),
            type: 'area',
          }],
          yAxis: {
            showExtremes: {
              min: true,
              max: true,
            }
          },
          tooltip: {
            valueSuffix: "€",
            pointFormat: this.$vuetify.breakpoint.smAndDown ? '{point.y}' : '{series.name}: {point.y}'
          },
          credits: {
            html:FinChartBuilder.createRealTimeCredits()
          },
          subscriptions: [
            {
              subscription: this.realtimeSubscription,
              trigger({data}, {chart}){
                const {price: y, timestamp} = data.onCreateRealTimePrice
                const x = (new Date(timestamp)).getTime()
                if(chart.series?.length){
                  const {selected} = chart.rangeSelector || {}
                  chart.series[0].addPoint([x, y], false, false)
                  const {min} = chart.xAxis[0].getExtremes()
                  chart.xAxis[0].setExtremes(min, x, true, true, { trigger: 'addPoint'})
                  chart.rangeSelector.clickButton(selected)
                }
              }
            }
          ]
        }
      }
    }
  },
}
</script>


<style lang="scss" scoped>
</style>
